module.exports = __webpack_public_path__ + "static/media/line.90cf1177.svg";